var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accessibility-filter-list"},_vm._l((_vm.options),function(option,index){return _c('filter-option',{key:index,ref:"options",refInFor:true,attrs:{"option":option,"settings":_vm.settings},on:{"pref-changed":_vm.prefChanged}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }